// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.settings.`data`.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import one.healthium.settings.`data`.dto.SettingsItemDto

@OptIn(InternalKtorfitApi::class)
public class _SettingsApiClientImpl(
  private val _ktorfit: Ktorfit,
) : SettingsApiClient {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override suspend fun getMenu(menuId: String): List<SettingsItemDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "${"$menuId".encodeURLPath()}.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<List<SettingsItemDto>>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _SettingsApiClientProvider : ClassProvider<SettingsApiClient> {
  override fun create(_ktorfit: Ktorfit): SettingsApiClient = _SettingsApiClientImpl(_ktorfit)
}

public fun Ktorfit.createSettingsApiClient(): SettingsApiClient = _SettingsApiClientImpl(this)
